import React from 'react';
import { useStripe, useElements, CardCvcElement, CardElement, CardExpiryElement, CardNumberElement } from '@stripe/react-stripe-js';

import CardSection from './CardSection';
import { Button } from 'primereact/button';
import { useEffect } from 'react';
import axios from 'axios';
import { useState } from 'react';
import { baseUrl } from '../../service/api';

export default function CheckoutForm({ invoiceId, payments, selectedCurrency }) {
    const stripe = useStripe();
    const elements = useElements();

    const [errorMessage, setErrorMessage] = useState(null)
    const [disabledBtn, setDisabledBtn] = useState(false)

    const handleSubmit = async (event) => {
        // We don't want to let default form submission happen here,
        // which would refresh the page.
        event.preventDefault();



        if (!stripe || !elements) {
            // Stripe.js has not yet loaded.
            // Make  sure to disable form submission until Stripe.js has loaded.
            return;
        }
        setDisabledBtn(true)
        const card = elements.getElement(CardElement);
        const result = await stripe.createToken(card);

        console.log(result.token)
        if (result.error) {
            console.log(result.error.message);
            setErrorMessage(result.error.message)
            setDisabledBtn(false)
        } else {
            setDisabledBtn(true)
            stripeTokenHandler(result.token);
        }
    };

    async function stripeTokenHandler(token) {
        const paymentData = { stripeToken: token.id, amount: payments.amount[selectedCurrency?.code], description: payments.name, email: payments.email, invoice_id: invoiceId };

        axios
            .post(`${baseUrl}/api/paymentStripe`, paymentData)
            .then((response) => {
                window.location.href = `/success?email=${payments.email}`
            })
            .catch((error) => {
                setDisabledBtn(false)
                console.error(error)
            })
    }

    return (
        <form onSubmit={handleSubmit}>
            <CardSection errorMessage={errorMessage} />
            {/*  <button disabled={!stripe}>Confirm order</button> */}
            <p className="select-title mt-5 mb-0">К оплате</p>
            <div id='aaa'></div>
            <p className="sum">
                {payments.amount[selectedCurrency?.code]} {selectedCurrency.symbol}
            </p>
            <Button disabled={disabledBtn} className="btn-pay w-full mt-4" label="Оплатить" />
        </form>
    );
}